module.exports = __webpack_public_path__ + "static/A5xF1 e010947394-v8.c607641e.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/A5xF1 e010947394-v8.jpg
// module id = 878
// module chunks = 168707334958949